<template>
	<v-hover v-slot="{ isHovering, props: hoverProps }">
		<span v-bind="hoverProps">
			<v-tooltip
				:text="tooltip"
				activator="parent"
				:location="tooltipLocation"
				:open-delay="tooltipOpenDelay"
				:disabled="!tooltip || disabled"
			/>
			<v-icon
				v-bind="$attrs"
				:class="{
					'metadata-toolbar-button': true,
					hidden: hidden,
					'drag-handle': draggable,
				}"
				:color="isHovering && !disabled ? 'secondary' : ''"
				:disabled="disabled"
				:size="size"
				:aria-label="tooltip || icon"
				tabindex="-1"
				@click="$emit('click', $event)"
			>
				{{ icon }}
			</v-icon>
		</span>
	</v-hover>
</template>

<script>
export default {
	name: "VMetadataHoverIcon",
	inheritAttrs: false,
	props: {
		disabled: { type: Boolean, default: false },
		draggable: { type: Boolean, default: false },
		hidden: { type: Boolean, default: false },
		icon: { type: String, default: "mdi-drag-horizontal" },
		size: { type: String, default: "x-small" },
		tooltip: { type: String, default: "" },
		tooltipLocation: { type: String, default: "bottom" },
		tooltipOpenDelay: { type: [Number, String], default: 1000 },
	},

	emits: ["click"],

	setup() {},

	data() {
		return {};
	},
	computed: {},

	methods: {},
};
</script>

<style lang="scss">
.hidden {
	visibility: hidden;
	pointer-events: none;
}
.metadata-toolbar-button {
	&.v-icon.v-icon::after {
		opacity: 0 !important;
	}
}
</style>
